import { FormattedMessage } from 'react-intl';

import RadioGroup from 'components/base/RadioGroup';
import { Button } from 'components/Button/styles';

import * as S from './style';

import {
  RadioCriticalGroupeNameType,
  RadioOptValueType,
  SelectCriticalityQualifiersProps,
} from './types';

const SelectCriticalityQualifiers: React.FC<SelectCriticalityQualifiersProps> =
  ({ selectedValue, setSelectedValue, confirmedCriticality }) => {
    const radioGroup: RadioCriticalGroupeNameType = 'criticalRadioGroup';

    const handleSetSelectedValue = (value: RadioOptValueType) => {
      setSelectedValue(value);
    };

    return (
      <>
        <S.DrawerContentTitle data-testid="SelectCriticalityQualifiersTitle">
          <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.VALIDATE.TITLE" />
        </S.DrawerContentTitle>

        <S.DrawerContentSubTitle>
          <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.VALIDATE.SUBTITLE" />
        </S.DrawerContentSubTitle>

        <S.DrawerContainerBox>
          <S.DrawerContentBoxNotCritical>
            <RadioGroup
              radioGroupName={radioGroup}
              valueInit="notCritical"
              selectedValue={selectedValue}
              onChangeRadio={() => handleSetSelectedValue('notCritical')}
            />
            <S.CriticalBadge isCritical={false}>
              <S.IsSignalCriticalText data-testid="criticalStatusText">
                <FormattedMessage id="CAREMATRIXCPTC.CRITICALSTATUS.FALSE" />
              </S.IsSignalCriticalText>
            </S.CriticalBadge>
          </S.DrawerContentBoxNotCritical>

          <S.DrawerContentBoxIsCritical>
            <S.RadioContent>
              <RadioGroup
                radioGroupName={radioGroup}
                valueInit="isCritical"
                selectedValue={selectedValue}
                onChangeRadio={() => handleSetSelectedValue('isCritical')}
              />

              <S.CriticalBadge isCritical>
                <S.IsSignalCriticalText data-testid="criticalStatusText">
                  <FormattedMessage id="CAREMATRIXCPTC.CRITICALSTATUS.TRUE" />
                </S.IsSignalCriticalText>
              </S.CriticalBadge>
            </S.RadioContent>

            <S.DrawerContentBoxTitle
              isCritical={selectedValue === 'isCritical'}
            >
              <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.SERIOUSRISK.TITLE" />
            </S.DrawerContentBoxTitle>

            <S.DrawerContentBoxListOl>
              <S.DrawerContentBoxListLi
                isCritical={selectedValue === 'isCritical'}
                marker="auto"
              >
                <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.LIST.SERIOUSRISK.LI.1" />
                <S.DrawerContentBoxListOl>
                  <S.DrawerContentBoxListLi
                    isCritical={selectedValue === 'isCritical'}
                    marker="lower-alpha"
                  >
                    <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.LIST.SERIOUSRISK.LI.a" />
                  </S.DrawerContentBoxListLi>
                  <S.DrawerContentBoxListLi
                    isCritical={selectedValue === 'isCritical'}
                    marker="lower-alpha"
                  >
                    <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.LIST.SERIOUSRISK.LI.b" />
                  </S.DrawerContentBoxListLi>
                </S.DrawerContentBoxListOl>
              </S.DrawerContentBoxListLi>
              <S.DrawerContentBoxListLi
                isCritical={selectedValue === 'isCritical'}
                marker="auto"
              >
                <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.LIST.SERIOUSRISK.LI.2" />
              </S.DrawerContentBoxListLi>
              <S.DrawerContentBoxListLi
                isCritical={selectedValue === 'isCritical'}
                marker="auto"
              >
                <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.LIST.SERIOUSRISK.LI.3" />
              </S.DrawerContentBoxListLi>
            </S.DrawerContentBoxListOl>

            <S.DrawerContentBoxTitle
              isCritical={selectedValue === 'isCritical'}
            >
              <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.HIGHRISK.TITLE" />
            </S.DrawerContentBoxTitle>

            <S.DrawerContentBoxListOl>
              <S.DrawerContentBoxListLi
                isCritical={selectedValue === 'isCritical'}
                marker="auto"
              >
                <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.LIST.HIGHRISK.LI.1" />
              </S.DrawerContentBoxListLi>

              <S.DrawerContentBoxListLi
                isCritical={selectedValue === 'isCritical'}
                marker="auto"
              >
                <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.LIST.HIGHRISK.LI.2" />
              </S.DrawerContentBoxListLi>

              <S.DrawerContentBoxListLi
                isCritical={selectedValue === 'isCritical'}
                marker="auto"
              >
                <FormattedMessage id="ENDUSER.DRAWER.CRITICAL.CONTENT.BOX.LIST.HIGHRISK.LI.3" />
              </S.DrawerContentBoxListLi>
            </S.DrawerContentBoxListOl>
          </S.DrawerContentBoxIsCritical>
        </S.DrawerContainerBox>

        <S.DrawerBoxFooter>
          <Button onClick={confirmedCriticality}>
            <FormattedMessage id="CONFIRM.CONFIRM.DEFAULT" />
          </Button>
        </S.DrawerBoxFooter>
      </>
    );
  };

export default SelectCriticalityQualifiers;
